export const DEPENSE_BAILLEUR_EDITION_CREATION = {
  titleCreation: 'Créer une facture bailleur',
  titleUpdate: 'Modifier facture bailleur n°{code}',
  titleAvoirCreation: 'Créer une facture avoir bailleur',
  titleAvoirUpdate: 'Modifier facture avoir bailleur n°{code}',
  breadcrumb: {
    racine: 'Accueil',
    listeBailleur: 'Liste factures bailleur',
    creation: 'Créer une facture bailleur',
    update: 'Modifier une facture bailleur',
    creationAvoir: 'Créer une facture avoir bailleur',
    updateAvoir: 'Modifier facture avoir bailleur',
  },
  actions: {
    cancel: 'Annuler',
    save: 'Brouillon',
  },
  onglet: {
    depenseBaileur: 'Facture bailleur',
    rapprochement: 'Rapprochement',
    echeancierPAiement: 'Echéancier de paiement',
    situation: 'Situation',
    editionLignesCommandes: 'Produits',
  },
  editionLignesCommandes: {
    title: 'Changement produits',
  },
  depenseBailleur: {
    title: 'Facture bailleur',
    referenceDepense: 'Référence de la facture',
    objetFacture: 'Objet de la facture',
    dateDepense: 'Date de la facture',
    referenceFournisseur: 'Référence fournisseur',
    codeDossier: 'Code dossier',
    agence: 'Agence',
    bailleur: 'Bailleur',
    datePaiement: 'Date de paiement',
    modePaiement: 'Mode de paiement',
    delaiPaiement: 'Délai de paiement',
    compteComptable: 'Compte comptable',
  },
  messages: {
    success: {
      editQuotationSuccess: 'Modification de la facture bailleur réalisée avec succès.',
      successCreation: 'Création de la facture bailleur réalisée avec succès.',
      sucessReinitialisationRapprochement: 'Le rapprochement à été reinitialisé avec les informations du bailleur',
      editFaturePayed: 'Modification de la facture réalisée avec succès.',
    },
    error: {
      name: {
        libelleLigneCommande: 'Libellé de la ligne',
        quantiteLigneCommande: 'Quantité de la ligne',
        prixUnitaireLigneCommande: 'Prix unitaire de la ligne',
        remiseLigneCommande: 'Remise de la ligne',
        tauxTvaLigneCommande: 'Taux de Tva de la ligne',
      },
      leastOneProduct: 'Vous devez saisir au minimum un produit dans la facture.',
      leastOneBailleur: 'Vous devez saisir au minimum un bailleur dans la facture.',
      TotalHtLowerThanDiscountLine: 'La remise dépasse le montant de l\'achat',
      quantityLessZero: 'La quantité des produits doit être supérieure à 0.',
      regulationModeRequired: 'Le mode de règlement est obligatoire.',
      settlementPeriodRequired: 'Le délai de règlement est obligatoire.',
      paymentDifferent: 'La somme des échéances est différente du montant total de l\'échéancier de paiement',
      dateDepense: 'Date de la facture',
      libelleObligatoire: 'Libéllé obligatoire',
      draftToDelete: 'Impossible de supprimer la facture bailleur {depenseBailleur} car elle n\'est pas à l\'état brouillon.',
      sumOfAmountExceedsBillsAmount: 'Le montant des rapprochements est supérieur au montant de la facture.',
      orderShouldBeReconciliable: 'La commande d\'achat {commandeAchat} doit être à rapprocher.',
      billShouldBeReconciliable: 'La facture doit être à rapprocher.',
      amountTooHight: 'Le montant à rapprocher pour la commande {commandeAchat} est trop important. Maximum autorisé : {maxAmount}.',
      commandeFullyReconciled: 'Le montant de la commande d\'achat {commandeAchat} est déja rapproché.',
      reconciliationDifferentProviders: 'Impossible de rapprocher des commandes d\'achat n\'appartenant pas au même bailleur.',
      productTypeInvalide: 'Le type de produit est invalide',
      productRequired: 'Impossible de supprimer la référence d\'un produit sur une ligne',
      echeanceEnregistreForRapprochement: 'Les échéances doivent être à l\'état "Enregistrée" pour être utilisées dans le rapprochement',
      echeanceEnregistreFacturePartiellementForRapprochement: 'Les échéances doivent être à l\'état "Enregistrée" ou "Facturée Partiellement" pour être utilisées dans le rapprochement',
      positiveNormalCommandLineForbidden: 'Il est interdit d\'avoir une ligne de commande normale positive',
      amountIncorrect: 'Si la facture est un avoir, son montant doit être négatif ou nul.',
      agence: 'Agence',
    },
  },
  popUpPrevention: {
    title: 'Vous n\'avez pas associé de période à votre dépense bailleur, cela va influencer le calcul des CCA pour la situation',
    subTitle: 'Souhaitez-vous continuer ?',
    titleWarningRapprochement: 'Vous n\'avez pas rapproché la première échéance à payer',
  },
  avoir: {
    messages: {
      success: {
        editQuotationSuccess: 'Modification de l\'avoir bailleur réalisée avec succès.',
        successCreation: 'Création de l\'avoir bailleur réalisée avec succès.',
        editFaturePayed: 'Modification de l\'avoir réalisée avec succès.',
      },
      error: {
        name: {
          libelleLigneCommande: 'Libellé de la ligne',
          quantiteLigneCommande: 'Quantité de la ligne',
          prixUnitaireLigneCommande: 'Prix unitaire de la ligne',
          remiseLigneCommande: 'Remise de la ligne',
          tauxTvaLigneCommande: 'Taux de Tva de la ligne',
        },
        leastOneProduct: 'Vous devez saisir au minimum un produit dans l\'avoir.',
        leastOneBailleur: 'Vous devez saisir au minimum un bailleur dans l\'avoir.',
        TotalHtLowerThanDiscountLine: 'La remise dépasse le montant de l\'achat',
        quantityLessZero: 'La quantité des produits doit être supérieure à 0.',
        regulationModeRequired: 'Le mode de règlement est obligatoire.',
        settlementPeriodRequired: 'Le délai de règlement est obligatoire.',
        paymentDifferent: 'La somme des échéances est différente du montant total de l\'échéancier de paiement',
        dateDepense: 'Date de l\'avoir',
        libelleObligatoire: 'Libellé obligatoire',
        draftToDelete: 'Impossible de supprimer l\'avoir bailleur {depenseBailleur} car elle n\'est pas à l\'état brouillon.',
        productTypeInvalide: 'Le type de produit est invalide',
        productRequired: 'Impossible de supprimer la référence d\'un produit sur une ligne',
        positiveNormalCommandLineForbidden: 'Il est interdit d\'avoir une ligne de commande normale positive',
        amountIncorrect: 'Si la facture est un avoir, son montant doit être négatif ou nul.',
        agence: 'Agence',
      },
    },
  },
};

export const LISTE_DEPENSE_BAILLEUR = {
  title: 'Liste des factures bailleur',
  breadcrumb: {
    racine: 'Accueil',
    listeDepenseBailleur: 'Liste factures bailleur',
  },
  delete: {
    title: 'Etes-vous sûr de vouloir supprimer cette facture bailleur ?',
    yes: 'Oui',
    no: 'Non',
    success: 'Facture bailleur supprimée avec succès.',
  },
  actions: {
    create: 'Créer une facture bailleur',
  },
  onglet: {
    depensesBailleur: 'Factures bailleur',
    echeanceAPayer: 'Echéances à payer',
  },
  tab: {
    depenseN: 'Facture n°',
    date: 'Date',
    bailleur: 'Bailleur',
    etat: 'Etat',
    montantHt: 'Montant HT',
    montantTtc: 'Montant TTC',
    montantPaye: 'Montant payé',
    sousType: 'Type',
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
    },
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence',
    bailleur: 'Bailleur',
    codeBail: 'Code bail',
    etat: 'Etat',
    periode: 'Date de facture',
    exporteeEnCompta: 'Exportée en compta',
    au: 'au',
    echeanceBail: 'Bail: {codeBail} ',
    echeanceBailleur: 'Bailleur: {bailleur} ',
    echeancePeriode: 'Echéance du {dateDebut} au {dateFin} ',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
};

export const DETAIL_DEPENSE_BAILLEUR = {
  title: 'Détail facture bailleur n°{code}',
  titleAvoir: 'Détail facture avoir bailleur n°{code}',
  actions: {
    generateEcriture: 'MAJ Ecriture',
    draft: 'Repasser en brouillon',
    avoir: 'Créer un avoir',
  },
  breadcrumb: {
    racine: 'Accueil',
    listeDepenseBailleur: 'Liste factures bailleur',
    detailDepenseBailleur: 'Détail d\'une facture bailleur',
  },
  onglet: {
    ecritureComptable: 'Ecriture comptable',
    depenseBailleur: 'Facture bailleur',
    rapprochement: 'Rapprochement',
  },
  popUpAvoir: {
    title: 'Vous êtes sur le point d\'annuler une facture bailleur.',
    annulerFacturePayer: 'Cette facture a déjà reçu un règlement. Il sera nécessaire de vérifier votre encours du tiers après la création de l\'avoir.',
    avoirMessage: 'Un avoir total ou partiel sur la facture n°',
    finAvoirMessage: '. Vous ne pouvez faire un avoir que sur le montant non rapproché',
    annulerConfirm: 'Souhaitez-vous annuler la facture n°',
    finAnnulerConfirm: ' ?',
    error: {
      rapprochee: 'Le montant de l\'avoir est supérieur au reste à rapprocher de la facture',
      totalementRapprochee: 'La facture est totalement rapprochée. Vous ne pouvez faire un avoir que sur le montant non rapproché',
    },
  },
  messages: {
    success: {
      generateEcriture: 'Ecriture mise à jour avec succès',
    },
  },
  referenceFournisseur: 'Référence fournisseur: {referenceFournisseur}',
};
